import { Step, StepConnector, StepLabel, Stepper, stepConnectorClasses, styled, Box } from '@mui/material';

// Styled components for step icons
// Using shouldForwardProp to prevent boolean props from being passed to DOM
const StepContainerRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed',
})(({ theme, active, completed }) => ({
  backgroundColor: 'transparent',
  zIndex: 1,
  color: '#fff',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: 'transparent',
  width: '23px',
  height: '23px',
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(active && {
    backgroundColor: '#fff',
    borderColor: theme.palette.primary.main,
  }),
  ...(completed && {
    backgroundColor: '#fff',
    borderColor: theme.palette.primary.main,
  }),
}));

const StepIconRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed',
})(({ theme, active, completed }) => ({
  backgroundColor: theme.palette.color?.grayFifth || '#eaeaea',
  zIndex: 1,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: theme.palette.primary.main,
  width: '13px',
  height: '13px',
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(active && {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  }),
  ...(completed && {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  }),
}));

const HalfStepIconRoot = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  zIndex: 1,
  borderWidth: '9px',
  borderStyle: 'solid',
  borderColor: theme.palette.primary.main,
  width: '0px',
  height: '0px',
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  borderLeftColor: '#fff',
  borderBottomColor: '#fff',
  transform: 'rotate(-135deg)',
}));

// Use MUI styled API for StepConnector
const StepsConnect = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: '12px',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: '3px',
    border: 0,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '1px',
  },
}));

const StepsLabelCustom = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepLabel-label': {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    color: theme.palette.color?.grayThird || '#96979a',
    marginTop: '5px',
    '&.Mui-active': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      fontSize: '16px',
      color: theme.palette.primary.main,
    },
    '&.Mui-completed': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      fontSize: '16px',
      color: theme.palette.primary.main,
    },
  },
}));

function StepIcons(props) {
  const { active, completed } = props;

  return (
    <StepContainerRoot active={active} completed={completed}>
      <StepIconRoot active={active} completed={completed} />
    </StepContainerRoot>
  );
}

function HalfStepIcon(props) {
  const { active, completed } = props;

  return (
    <StepContainerRoot active={active} completed={completed}>
      <HalfStepIconRoot />
    </StepContainerRoot>
  );
}

function DriverStepper({ half = null, currentStep }) {
  const steps = ['Profile', 'Vehicle', 'Account'];

  return (
    <Stepper activeStep={currentStep} alternativeLabel connector={<StepsConnect />}>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepsLabelCustom StepIconComponent={half === index ? HalfStepIcon : StepIcons}>{label}</StepsLabelCustom>
        </Step>
      ))}
    </Stepper>
  );
}

export default DriverStepper;
